import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
  Input,
} from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

const VehicleForm = ({ register, errors }) => {
  const { t } = useTranslation();

  return (
    <Grid templateColumns={"auto"} templateRows={"auto"} gap={"8px"}>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.licensePlate}>
          <FormLabel fontSize={12} htmlFor={"licensePlate"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.licensePlate.title</Trans>
          </FormLabel>
          <Input
            id={"licensePlate"}
            placeholder={t("beneficiaryFile.form.licensePlate.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("licensePlate", {
              required: t("beneficiaryFile.form.licensePlate.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.licensePlate && errors.licensePlate.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.serialNumber}>
          <FormLabel fontSize={12} htmlFor={"serialNumber"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.serialNumber.title</Trans>
          </FormLabel>
          <Input
            id={"serialNumber"}
            placeholder={t("beneficiaryFile.form.serialNumber.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("serialNumber", {
              required: t("beneficiaryFile.form.serialNumber.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.serialNumber && errors.serialNumber.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.brand}>
          <FormLabel fontSize={12} htmlFor={"brand"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.brand.title</Trans>
          </FormLabel>
          <Input
            id={"brand"}
            placeholder={t("beneficiaryFile.form.brand.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("brand", {
              required: t("beneficiaryFile.form.brand.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.brand && errors.brand.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl isInvalid={errors.model}>
          <FormLabel fontSize={12} htmlFor={"model"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.model.title</Trans>
          </FormLabel>
          <Input
            id={"model"}
            placeholder={t("beneficiaryFile.form.model.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("model", {
              required: t("beneficiaryFile.form.model.required"),
            })}
          />
          <FormErrorMessage fontSize={8}>
            {errors.model && errors.model.message}
          </FormErrorMessage>
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"registrationDate"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.registrationDate.title</Trans>
          </FormLabel>
          <Input
            id={"registrationDate"}
            type={"date"}
            style={{ colorScheme: "dark" }}
            backgroundColor={"#2D313A"}
            {...register("registrationDate")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"mileage"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.mileage.title</Trans>
          </FormLabel>
          <Input
            id={"mileage"}
            placeholder={t("beneficiaryFile.form.mileage.placeholder")}
            type={"number"}
            backgroundColor={"#2D313A"}
            {...register("mileage")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"gearbox"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.gearBox.title</Trans>
          </FormLabel>
          <Input
            id={"gearbox"}
            placeholder={t("beneficiaryFile.form.gearBox.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("gearbox")}
          />
        </FormControl>
      </GridItem>
      <GridItem colSpan={1} rowSpan={1}>
        <FormControl>
          <FormLabel fontSize={12} htmlFor={"energy"} fontWeight={400} color={"white"}>
            <Trans>beneficiaryFile.form.energy.title</Trans>
          </FormLabel>
          <Input
            id={"energy"}
            placeholder={t("beneficiaryFile.form.energy.placeholder")}
            type={"text"}
            backgroundColor={"#2D313A"}
            {...register("energy")}
          />
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default VehicleForm;
